import { useEffect, useRef } from "react";
import { useFaust } from "../../contexts/FaustContext";
import { Scope } from "../../Scope";
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { AudioLines } from "lucide-react";

type ScopeCanvasProps = {
    type: "input" | "output";
};

export function ScopeCanvas({ type }: ScopeCanvasProps) {
    const { audioEnvRef } = useFaust();
    const containerRef = useRef<HTMLDivElement>(null);
    const scopeRef = useRef<Scope | null>(null);

    useEffect(() => {
        if (!containerRef.current) return;
        const audioEnv = audioEnvRef.current;
        if (!audioEnv.audioCtx) return;

        const analyser = type === "input" ? audioEnv.analyserInput : audioEnv.analyserOutput;
        const splitter = type === "input" ? audioEnv.splitterInput : audioEnv.splitterOutput;

        if (!analyser) return;

        const scope = new Scope({
            audioCtx: audioEnv.audioCtx,
            analyser,
            splitter: splitter || audioEnv.audioCtx.createChannelSplitter(1),
            channels: type === "input" ? 2 : 1,
            container: containerRef.current,
        });

        scopeRef.current = scope;

        return () => {
            scope.disabled = true;
        };
    }, [audioEnvRef, type]);

    return (
        <div className="scope-container" ref={containerRef}>
            {/* Scope creates its own canvas inside the container ref */}
        </div>
    );
}
